// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fulfilment-slots-modal h1[data-v-187d250a]{margin-bottom:1rem}.fulfilment-slots-modal .fulfilment-slots[data-v-187d250a]{display:flex;flex-direction:column;gap:1rem}", ""]);
// Exports
module.exports = exports;
